module.exports = __webpack_public_path__ + "img/scan_extraction.01d52651.svg";